import('../src/javascripts/attachments-redesign');
import('../src/javascripts/navigation');
import('../src/javascripts/modal_dialog');

// chat AI
import('../src/javascripts/chat-bot-form');
